(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	// require('slick-carousel');

	$('[data-timeline]').each(function () {
		var wrap = $(this);
		var nav = wrap.find('[data-timeline-nav]');
		var content = wrap.find('[data-timeline-content]');
		var maxNavSlides = window.matchMedia('(min-width: 760px)').matches ? 5 : 3;
		var navSlidesToShow = nav.find('> *').length - 1; // Total number of navs needs to be at least one more than the number shown (for slick's centerMode to work properly)
			navSlidesToShow = navSlidesToShow > 0 ? navSlidesToShow : 1; // Make sure we show a positive number of slides
			navSlidesToShow = navSlidesToShow > maxNavSlides ? maxNavSlides : navSlidesToShow; // Make sure not to show too many
		var centerMode = navSlidesToShow > 1 ? true : false; // Don't even use centerMode if we're only showing one(? why?)

		nav.slick({
			dots: false,
			arrows: true,
			slidesToShow: navSlidesToShow,
			slidesToScroll: 1,
			centerMode: centerMode,
			asNavFor: content,
			focusOnSelect: centerMode,
			prevArrow: '<a role="button" class="slick-prev icon-left icon--round icon--round--ghost"></a>',
			nextArrow: '<a role="button" class="slick-next icon-right icon--round icon--round--ghost"></a>'
		});

		content.slick({
			dots: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: nav,
			adaptiveHeight: true
		});
	});
})();
